import React from 'react';

import { TThemeType } from '_style/style';

import { StyledDot, StyledLoadingDots } from './style';

interface Props {
  color?: keyof TThemeType['color'];
  size?: number;
}

const LoadingDots = ({ color = 'grey52', size = 6 }: Props) => (
  <StyledLoadingDots $size={size}>
    <StyledDot $color={color} $delay={0} $size={size} />
    <StyledDot $color={color} $delay={150} $size={size} />
    <StyledDot $color={color} $delay={300} $size={size} />
  </StyledLoadingDots>
);

export default LoadingDots;
